import { ITemperatureControl } from '@grc/ui-shared/lib/components/models/order/ITemperatureControlled';
import { IDimensions, IUnit } from './dimensions.interface';

export interface IHandlingUnit {
  handlingUnitId: string;
  handlingUnitTypeId: string;
  handlingUnitType: string;
  quantity: number;
  dimensions: IDimensions;
  weight: IUnit;
  nmfc: string;
  nmfcClassId: string;
  nmfcClassName: string;
  productDescription: string;
  hasHazmat: boolean;
  isNonStackable: boolean;
  hazmat?: IHazmat;
  temperatureControl?: ITemperatureControl;
  hasTemperatureControl?: boolean;
}

export interface IHazmat {
  unitedNationsNumber: string;
  properShippingName: string;
  hazardClass: HazardClass;
  packagingGroup: IPackingGroup;
  emergencyResponsePersonName: string;
  emergencyResponseContactType: string;
  emergencyResponseContact: string;
  emergencyResponseEmail?: string;
}

export enum IPackingGroup {
  Single,
  Composite,
  Combination
}

export enum HazardClass {
  Class1 = 1,
  Class2 = 2,
  Class3 = 3,
  Class4 = 4,
  Class5 = 5,
  Class6 = 6,
  Class7 = 7,
  Class8 = 8,
  Class9 = 9
}
